export const SET_POSIBLE_FILTER_OPTIONS = 'SET_POSIBLE_FILTER_OPTIONS';
